<template>
  <div id="wrapper">
    <TextHeader :headerTitle="$t('events.announcements')" />
    <div class="w-container" v-if="announcements">
      <SectionHeader :text="$t('events.announcements')" />
      <div :key="item.id" v-for="item in announcements" class="announcement">
        <h4>{{ item.title }}</h4>
        <div class="date">{{ item.date }}</div>
        <div v-html="item.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import TextHeader from "./TextHeader";
import SectionHeader from "./SectionHeader";

export default {
  name: "Announcement",
  components: { SectionHeader, TextHeader },
  data() {
    return {
      announcements: null
    };
  },
  mounted() {
    this.$http
      .get("announcement/")
      .then(response => (this.announcements = response.data.reverse()));
  }
};
</script>

<style scoped>
#wrapper {
  min-height: 80vh;
}

.w-container {
  padding: 5vh 0;
}

.announcement {
  padding: 80px 0 20px 0;
  border-bottom: 1px solid #cccccc;
}

a,
a:visited {
  color: black;
}

.date {
  color: #999;
  padding: 20px 0 30px 0;
}
</style>
